module.exports = __webpack_public_path__ + "img/bg13@2x.a8cdecd0.jpg";